import Model from '@/models/BaseModel'
import PlanPackageModule from './PlanPackageModule'
import i18n from '@/plugins/i18n'

export default class PlanPackage extends Model {
    resourceName() {
        return 'plan-packages'
    }

    fields() {
        return [
            'id',
            'name',
            'price',
            'order',
            'corporate',
            'external_id',
            'available_for_selection',
            'default_anual_discount',
            'config_price',
            'description',
            'max_installments',
            'channel',
            'created_at',
            'updated_at',
            'deleted_at',
        ]
    }

    dates() {
        return {
            deleted_at: 'YYYY-MM-DD',
            created_at: 'YYYY-MM-DD',
            updated_at: 'YYYY-MM-DD',
        }
    }

    relationships() {
        return {
            modules: new PlanPackageModule(),
        }
    }

    get formattedPrice() {
        return i18n.n(this.price, 'currency')
    }

    get searchable() {
        return ['name']
    }

    get isDeleted() {
        return !this.deleted_at || !this.deleted_at.isValid()
    }

    get isChannel() {
        return this.channel
    }

    get tableColumns() {
        return [
            {
                text: '#',
                value: 'id',
            },
            {
                text: i18n.t('planPackages.index.table.headers.name'),
                value: 'name',
            },
            {
                text: i18n.t('planPackages.index.table.headers.price'),
                value: 'formattedPrice',
                width: 200,
                sortable: false,
            },
            {
                text: i18n.t(
                    'planPackages.index.table.headers.available_for_selection',
                ),
                value: 'available_for_selection',
                width: 220,
                sortable: false,
            },
            {
                text: i18n.t('tables.actions'),
                value: 'action',
                sortable: false,
                width: 150,
                align: 'end',
            },
        ]
    }

    get actions() {
        return [
            {
                type: 'show-modules',
                icon: 'mdi-format-list-bulleted-square',
                color: 'blue-grey',
                label: i18n.t('planPackages.actions.show-modules'),
                to: {
                    name: 'planPackageModules.index',
                    params: { id: this.id },
                },
                hide: !this.isDeleted,
            },
            {
                type: 'edit',
                to: { name: 'planPackages.edit', params: { id: this.id } },
                hide: !this.isDeleted || !this.isChannel,
            },
            {
                type: 'delete',
                hide: !this.isDeleted || !this.isChannel,
            },
            {
                type: 'restore',
                hide: this.isDeleted || !this.isChannel,
            },
        ]
    }

    restore() {
        return this.makePersistRequest({
            url: `${this.getSelfUrl()}/restore`,
            method: 'POST',
            data: this.data(),
        })
    }
}
